// Company data for a CNPJ, from the public BrasilAPI. The one lookup every form that takes a
// CNPJ uses (billing identification, contract counterparty). Null when the CNPJ is unknown,
// the service is down, or the browser is offline: callers keep what the person typed.
export const fetchCompanyByCnpj = async (cnpjDigits) => {
  try {
    const response = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpjDigits}`)
    if (!response.ok) return null
    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar CNPJ:', error)
    return null
  }
}
